import {Component, OnInit, ViewChild} from '@angular/core';
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";

@Component({
    selector: 'app-thank-you-modal',
    templateUrl: './thank-you-modal.component.html',
    styleUrls: ['./thank-you-modal.component.scss']
})
export class ThankYouModalComponent {
    @ViewChild('thankYouModal') thankYouModal: any;
    modalRef: BsModalRef;
    config = {
        ignoreBackdropClick: true
    };
    constructor(public modalService: BsModalService) {
    }
    
    onShow(): void {
        this.modalRef = this.modalService.show(this.thankYouModal, this.config);
    }

    hideModal() {
        this.modalRef.hide();
    }
}
